import { type FC } from "react";

import { storageEngine, TYPE } from "~/common/utils/storage";
import { getAccountsData } from "~/features/b2bAccountSelection/components/AccountSelectionTabelView/api/GetAccountList";
import { useBooleanState } from "~/common/hooks/useBooleanState";
import { userCanSeeMyCompanySettings } from "~/features/myAccount/dashboard/helper/permissions";
import { HOMEPAGE } from "~/utils/url/staticUrls";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { OrderQuoteNotificationsPage as OrderQuoteNotificationsContent } from "~/features/myAccount/orderQuoteNotifications/OrderQuoteNotificationsPage";
import Spinner from "~/common/components/Spinner/Spinner";
import { userIsLoggedIn } from "~/domains/user/utils/roles";

export function createOrderQuoteNotificationsPage() {
  return <OrderQuoteNotificationsInit />;
}

export const OrderQuoteNotificationsInit: FC = () => {
  const { val: ready, setTrue } = useBooleanState(false);

  // guard route
  if (!userCanSeeMyCompanySettings() || !userIsLoggedIn()) {
    redirectToUrl(HOMEPAGE);
    return null;
  }

  const accounts = storageEngine(TYPE.SESSION).getItem("userAccounts");
  // check again for accounts (in case Client didn't reach Select Account)
  if (null === accounts) {
    getAccountsData()
      .then((accounts) => {
        storageEngine(TYPE.SESSION).setItem("userAccounts", JSON.stringify(accounts.rows));
      })
      .finally(() => setTrue());
  }
  // check for ready is FALSE to prevent re-render loop after setTrue is called
  if (null !== accounts && !ready) {
    setTrue();
  }
  return ready ? <OrderQuoteNotificationsContent /> : <Spinner />;
};
